export * from './sexo-beneficiario.pipe';
